export default {
    title: 'E-Mail an Antragsteller',
    maxProcessesForCreatorUserMail: 'Es können max. {max} Mails gleichzeitig verschickt werden.',
    sendingCountMails: 'Es werden {count} E-Mails an Antragsteller verschickt.|Es wird {count} E-Mail an Antragsteller verschickt.|Es werden {count} E-Mails an Antragsteller verschickt.',

    showHelp: 'Hilfe einblenden',
    hideHelp: 'Hilfe ausblenden',

    sendCreatorUserMail: 'Sende E-Mail an Antragsteller',

    creatorUserMailSentSuccessfully: 'E-Mail an Antragsteller erfolgreich gesendet',
    errorOnSendingCreatorUserMail: 'Fehler beim Senden der E-Mail an den Antragsteller',
}